/* P-171: la calificación de empleado que decide RRHH. Lo puro.
 *
 * Pedido de Nico: «que la gente de personal pueda decidir si es buen/maso/mal
 * empleado y que se muestre al lado del nombre con puntitos de colores: verde
 * buen chofer, amarillo regular, rojo no tomar nunca más».
 *
 * NO ES EL SEMÁFORO DE LA NÓMINA. Aquella luz (verde/amarillo) sale de las
 * NOVEDADES —una licencia o suspensión vigente—: es un estado de hoy y
 * automático. Esto es una OPINIÓN de RRHH sobre la persona, cargada a mano.
 * Por eso son dos datos distintos, con dos íconos distintos, y este vive en su
 * propia tabla (`personal_calificacion`). El puntito va DETRÁS del nombre, para
 * no pisarse con la luz de novedades que va adelante.
 *
 * Se usan emojis y no la luz CSS de la nómina, justamente para que se vean
 * distintos de un vistazo y nadie confunda «tiene una licencia» con «es un
 * mal empleado».
 */

export const NIVELES = [
  { id: "bueno", label: "Buen empleado", corto: "Bueno", dot: "🟢" },
  { id: "regular", label: "Regular", corto: "Regular", dot: "🟡" },
  { id: "malo", label: "No tomar más", corto: "No tomar", dot: "🔴" },
];

/* El nivel entero, o null si no está calificado o el valor es desconocido.
 * Un valor viejo/raro no rompe: se trata como sin calificar. */
export const nivelDe = (id) => NIVELES.find((n) => n.id === id) || null;

/* El puntito de color, o "" si no está calificado. */
export const dotDe = (id) => nivelDe(id)?.dot || "";

/* Cómo se lee, para el globo y el aria-label. */
export const rotuloCalif = (id) => nivelDe(id)?.label || "Sin calificar";
